import { useContext } from "react";
import ViewContext from "search-filter/contexts/ViewContext";
const useView = () => useContext(ViewContext);
export default useView;
